import PropTypes from 'prop-types';
import fields from './fields';
import BackLink from '../backLink';
import AuthFormLayout from '../authFormLayout';
import { ReactComponent as SendIcon } from '../../../assets/icons/send.svg';

const ForgottenPasswordFormLayout = props => {
  const { translations, navigate } = props;

  return (
    <AuthFormLayout
      {...props}
      subtitleVariant="body1"
      icon={SendIcon}
      fields={fields}
    >
      <BackLink title={translations.backLink} navigate={navigate} to="/login" />
    </AuthFormLayout>
  );
};

ForgottenPasswordFormLayout.propTypes = {
  translations: PropTypes.object.isRequired,
};

export default ForgottenPasswordFormLayout;
